<script>
  import { _ as t, locale } from "svelte-i18n";

  export let options;
  export let key;
  export let value;
</script>

<style>
  .select-css {
    display: block;
    font-size: 16px;
    height: 55px;
    font-weight: 200;
    color: #0081c4;
    padding: 15px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0;
    border: 1px solid #bdbdbd;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;

    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgMUw2IDZMMTEgMSIgc3Ryb2tlPSIjMDA4MUM0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=);
    background-repeat: no-repeat, repeat;
    background-position: right 0.7em top 50%, 0 0;
    background-size: 0.65em auto, 100%;
  }
  .select-css::-ms-expand {
    display: none;
  }
  .select-css:hover {
    border-color: #888;
  }
  .select-css:focus {
    border-color: #aaa;
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #0081c4;
    outline: none;
  }
  .select-css option {
    font-weight: normal;
  }
</style>

<select name={key} bind:value class="select-css">
  <option value="" disabled selected>{$t('registration.placeholder')}</option>
  {#each options as option}
    <option value={option}>{option}</option>
  {/each}
</select>
